package kz.dentalcrm.app.data.network.request_model

import kotlinx.serialization.EncodeDefault
import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@OptIn(ExperimentalSerializationApi::class)
@Serializable
data class StoreTreatmentRequest(
    @SerialName("template_id")
    val templateId: String?,
    @SerialName("appointment_id")
    val appointmentId: String,
    @EncodeDefault
    @SerialName("tooth_number")
    val toothNumber: Int = 0,
    @SerialName("diagnosis_id")
    val diagnosisId: String,
    @EncodeDefault
    @SerialName("is_finished")
    val isFinished: Boolean = false,
    @EncodeDefault
    val teeth: List<String> = emptyList(),
    @EncodeDefault
    val data: List<TreatmentDataItem> = emptyList()
)

@Serializable
data class TreatmentDataItem(
    @SerialName("type_id")
    val typeId: Int,
    @SerialName("option_id")
    val optionId: Int,
    @SerialName("is_checked")
    val isChecked: Boolean = true
)
